import { createStore, applyMiddleware, compose} from 'redux';
//import { modelReducer } from 'redux-simple-router';
import reducers from "./reducers";
import thunk from "redux-thunk";

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const store = createStore(reducers, /* preloadedState, */ composeEnhancers(
  applyMiddleware(thunk) 
 ));

export default store;